export default __webpack_public_path__ + "static/media/linkedin-icon.9bd7e645.svg";